import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "date-range-picker-wrapper" }
const _hoisted_2 = { class: "preset-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_menu, {
      modelValue: _ctx.menuOpen,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.menuOpen) = $event)),
      "close-on-content-click": false,
      location: "bottom start",
      transition: "scale-transition"
    }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_text_field, _mergeProps(props, {
          "model-value": _ctx.displayValue,
          readonly: "",
          variant: "outlined",
          density: "compact",
          placeholder: "日付を選択",
          "prepend-inner-icon": "mdi-calendar",
          class: "date-range-input",
          "hide-details": ""
        }), null, 16 /* FULL_PROPS */, ["model-value"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "date-picker-card",
          "min-width": "320"
        }, {
          default: _withCtx(() => [
            _createCommentVNode(" Preset buttons "),
            _createVNode(_component_v_card_text, { class: "preset-section pa-2" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presetDates, (preset) => {
                    return (_openBlock(), _createBlock(_component_v_btn, {
                      key: preset.label,
                      size: "small",
                      variant: "text",
                      class: "preset-btn",
                      onClick: ($event: any) => (_ctx.applyPreset(preset.value))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(preset.label), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_divider),
            _createCommentVNode(" Date Picker "),
            _createVNode(_component_v_date_picker, {
              modelValue: _ctx.internalRange,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalRange) = $event)),
                _ctx.onDateChange
              ],
              multiple: "range",
              color: "primary",
              "show-adjacent-months": ""
            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, { class: "pa-2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  size: "small",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.menuOpen = false))
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" キャンセル ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  size: "small",
                  onClick: _ctx.confirmSelection
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" 適用 ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}